import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "../base.component";


@Component({
    selector: 'skitbs-template',
    template: `

        <!-- command-buttons confirmation dialog -->
        <p-confirmDialog header="{{v('warning')}}" icon="pi pi-exclamation-triangle BsFsMedium" [rejectLabel]="v('no')" [acceptLabel]="v('yes')" [message]="v('pleaseConfirm')"></p-confirmDialog>
        
        <!-- header -->
        <template-header>

            <!-- header- title -->
            <div class="HideOnDesktop TexAlCenter FontBold" *ngIf="title">
                {{title}}
            </div>

            <!-- header-custom-content -->
            <ng-content select="[facetHeader]"></ng-content>
        </template-header>


        <!-- content- title -->
        <div class="HideOnMobile SoftGrayBack FontBold MarB" *ngIf="title">
            <div class="d-flex-stretch">
                <div style="width: 4px; min-height: 5px;" class="GrayBack"></div>
                <div class="SoftGrayBack PadAll ">{{title}}</div>
            </div>
        </div>


        <!-- content -->
        <div class="OvAuto">
            <ng-content></ng-content>
        </div>


        <!-- footer -->
        <template-footer></template-footer>
    `
})
export class TemplateComponent extends BaseComponent {

    @Input() title: string;
    @Output() clickEmitter = new EventEmitter<string>();


    /**
     * Emitts click-events to parent components
     * @param aClickType
     */
    public emitClick(aClickType: string) {
        this.logi("emitting click event: " + aClickType);
        this.clickEmitter.emit(aClickType);
    }

}
